/* eslint-disable no-nested-ternary */
import React from 'react';
import {
    getPlaceHolderUnsupport,
    updateBgImageSrcRect,
    getSize,
} from './utils';
import RenderIframe from './addon/render-iframe';
import connect from '@src/js/separate-logic/connect';
import ShapeElementModel from './shape-element-model';
import ShapeElementPresenter from './shape-element-presenter';

import PropTypes from 'prop-types';
import Attachment from '@editor/src/page/index/components/canvas/attachment';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { isAttachmentShapeModel, isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { AttachmentClassify } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';

interface IShapeElementProps{
    component: any;
    rect: any;
    editorFocus: boolean;
    isPlaceHolder: boolean;
    region: string;
    editable: boolean;
    fromScale: number;
    datetime: Date;
    getLevelChangeLock: () => boolean;
    isCroping: boolean;
    setRef: (name: string, ref: any) => void;
    handleClick: (e) => void | undefined;
    handleDblClick: (e) => void;
    handleElementTouchStart: () => void;
    handleMouseEnter: () => void;
    handleMouseLeave: () => void;
    rotate: number;
    getPageScale: () => number;
    relativeRotate: number;
    relativeFlipH: number;
    relativeFlipV: number;
    isPreview: boolean;
    onElementUpdate: () => void;
    getLinkData: () => any;
    selectable: boolean;
    setResize: boolean;
    event: any;
    setResizeValue: (boolean) => void;
    toScaleView: any;
    mobileEditMode?: () => boolean;
    handleInput: () => void;
    handleChange: ({ textBodyStyle, paragraphList }) => void;
    handleSelectionChange: () => void;
    handleEditorStyleChange: () => void;
    handleEditorClick: () => void;
    handleEditorMouseDown: (e) => any;
    openMobileEditMode: (callback) => void;
    handleEditorContentChange: () => void;
    handleEditorOperation: () => void;
    handleEnterEditing: () => void;
    handleExitEditing: () => void;
    handlePlaceHolderClick: (type, e) => void;
    isSelected: (component) => boolean;
    redoHandler: () => void;
    undoHandler: () => void;
    handleTextChange: () => void;
    setPrevent: () => void;
    getPrevent: () => boolean;
    setPathRef: (key, ref) => void;
    onAttachmentFirstShow: () => void;
    getMediaManager(): IMediaManager | undefined;
}
class ShapeElement extends React.Component<IShapeElementProps> {
    public static displayName = 'ShapeElement'; // 声明displayName，单元测试用于查找组件

    public static defaultProps = {
        setRef: () => {},
        getLevelChangeLock: () => {},
        getLinkData: () => {},
        handleDblClick: () => {},
        isSelected: () => false,
    };

    /* eslint-disable complexity */
    public render() {
        // props 属性
        const { component, rect } = this.props;
        const mediaManager = this.props.getMediaManager();

        const isShowElement = ((component.key === mediaManager?.elementKey) && mediaManager?.isShowIframe)
            || isAttachmentShapeModel(component)
            || this.isInMobileSlideList();

        const componentProps = component.props;
        const size = getSize(rect, componentProps);
        // 部分ph做不显示处理
        if (getPlaceHolderUnsupport(component)) return null;

        updateBgImageSrcRect(componentProps, rect);

        component.updateState.editorShouldUpdate = false;

        return (
            <React.Fragment>
                {
                    isShowElement && component.props.addon && this.renderIframe(size)
                }
                {
                    this.renderAttachmentOrNot()
                }
            </React.Fragment>
        );
    }

    private isInMobileSlideList = () => browser.isMobile && !this.props.mobileEditMode?.();

    private renderIframe = (size) => {
        const { addon } = this.props.component?.props || {};
        const isSelected = this.props.component?.selected;
        if (!isIframeShapeModel(this.props.component)) {
            return null;
        }
        // 移动端预览态currentSlideIndex 均为-1 所以全显示缩略图
        return (
            <RenderIframe
                size={size}
                addon={addon}
                isSelected={isSelected}
                component={this.props.component}
                toScaleView={this.props.toScaleView}
                mobileEditMode={this.props.mobileEditMode}
            />
        );
    };

    private renderAttachmentOrNot = () => {
        const { attachment } = this.props.component?.props || {};
        const isVideo = attachment?.classify === AttachmentClassify.VIDEO;
        // video(上传状态) 传入 attachment 信息保持和 attachment-manager 中一致
        const attachmentManager = this.props.component.getAttachmentManager();
        const localVideoAttachment = attachmentManager?.uploadingMap.get(attachment?.id)?.attachment;
        if (attachment) {
            // 如果是视频附件并且尚未获取到 objKey，在没有 localVideoAttachment 的情况下不显示
            if (isVideo && !attachment.objKey) {
                return (localVideoAttachment || attachmentManager.isUploadError(this.props.component.id as string))
                    ? <Attachment
                        attachment={isVideo ? { ...localVideoAttachment, ...attachment  } : attachment}
                        onAttachmentFirstShow={this.props.onAttachmentFirstShow}
                        uiModel={this.props.component}
                    />
                    : null;
            }
            return (
                <Attachment
                    attachment={attachment}
                    onAttachmentFirstShow={this.props.onAttachmentFirstShow}
                    uiModel={this.props.component}
                />
            );
        }
        return null;
    };
}

export default connect(
    ShapeElementPresenter,
    ShapeElementModel,
    ShapeElement,
);
